"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useMouse = function (ref) {
    var frame = react_1.useRef(0);
    var _a = react_1.useState({
        docX: 0,
        docY: 0,
        posX: 0,
        posY: 0,
        elX: 0,
        elY: 0,
        elH: 0,
        elW: 0,
    }), state = _a[0], setState = _a[1];
    react_1.useEffect(function () {
        var handler = function (event) {
            cancelAnimationFrame(frame.current);
            frame.current = requestAnimationFrame(function () {
                if (ref && ref.current) {
                    var _a = ref.current.getBoundingClientRect(), left = _a.left, top_1 = _a.top, width = _a.width, height = _a.height;
                    var posX = left + window.scrollX;
                    var posY = top_1 + window.scrollY;
                    setState({
                        docX: event.pageX,
                        docY: event.pageY,
                        posX: posX,
                        posY: posY,
                        elX: event.pageX - posX,
                        elY: event.pageY - posY,
                        elH: height,
                        elW: width,
                    });
                }
            });
        };
        document.addEventListener('mousemove', handler);
        return function () {
            cancelAnimationFrame(frame.current);
            document.removeEventListener('mousemove', handler);
        };
    }, []);
    return state;
};
exports.default = useMouse;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-use/lib/useMouse.js
// module id = 1218
// module chunks = 17